module.exports = __webpack_public_path__ + "static/media/personalisedScreen.c116621c.png";